import React from 'react';

import { coplannerIcon } from '@/assets/icons';
import { copilotUrl } from '@/config/urls';
import { classNames } from '@/helpers/classNames';
import { useAuth } from '@/providers/AuthProvider';
import { useIntercom } from '@/providers/IntercomProvider/IntercomProvider';
import { SvgIcon } from '@material-ui/core';

import styles from './CopilotHeader.module.scss';

type CopilotHeaderProps = {
	className?: string;
};

export const CopilotHeader: React.FC<CopilotHeaderProps> = ({
	className,
	children,
}) => {
	const { logout, user } = useAuth();
	const { openIntercom } = useIntercom();
	const classes = classNames([styles['root'], className]);

	return (
		<div className={classes}>
			<div className={styles['left']}>
				<SvgIcon component={coplannerIcon} viewBox="0 0 124 32" />
				{/*//<span>Asaph Coplanner</span>} */}
			</div>
			<div className={styles['right']}>
				<div
					className={classNames([
						styles['trial-chip'],
						styles['hover'],
					])}
					onClick={() =>
						logout({
							redirectUrl: copilotUrl,
						})
					}
				>
					Logout, {user.email}
				</div>
				<div
					className={classNames([
						styles['trial-chip'],
						styles['hover'],
					])}
					onClick={openIntercom}
				>
					Help
				</div>
				{/* <span>
					Keep features? <a>Get Plan</a>
				</span> */}
			</div>
		</div>
	);
};
